import React, { useRef, useState, KeyboardEvent, ChangeEvent, useEffect } from 'react';
import Swal from 'sweetalert2';
import { API_Add_Category, API_Get_Work } from '../../Utils/api';

interface ItemStruct {
    id_work: string
    name_category: string
}

interface Struct {
    refresh: () => void
}

const Category_Add = (props : Struct) => {

    const [Toggle, setToggle] = useState(false);

    const Data = useRef<ItemStruct>({
        id_work: '',
        name_category: '',
    });

    const [Error, setError] = useState({
        id_work: false,
        name_category: false,
    });

    const [Work, setWork] = useState([]);

    const onEnter = (event : KeyboardEvent<HTMLInputElement>) : void => {
        event.key === 'Enter' && onSubmitData()
    }

    const onEsc = () : void => {
        document.onkeydown = (event) => {
            event.keyCode === 27 && setToggle(false);
        }
    }

    const onSubmitData = () : void => {
        if (
            CheckEmpty(Data.current.id_work, 'id_work') &&
            CheckEmpty(Data.current.name_category, 'name_category')
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'คำเตือน',
                text: 'คุณต้องการที่จะเพิ่มหมวดงาน ใช่ หรือ ไม่?',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'ใช่',
                cancelButtonText: 'ไม่',
            }).then(result => {
                if (result.value) {
                    PostData();
                }
            });
        }
    }

    const CheckEmpty = (value: string, id : string) : boolean => {
        if (value !== '') {
            setError(preState => ({
                ...preState,
                [id]: false
            }));
            return true;
        } else {
            document.getElementById(id)?.focus();
            setError(preState => ({
                ...preState,
                [id]: true
            }));
            return false;
        }
    }

    const PostData = () : void => {
        API_Add_Category(Data.current).then(res => {
            Swal.fire({
                icon: res.status ? 'success' : 'error',
                title: res.status ? 'สำเสร็จ' : 'เกิดข้อผิดพลาด',
                text: res.message,
                timer: 5000,
                timerProgressBar: true,
            }).then(() => {
                if (res.status) {
                    props.refresh();
                    ClearInput();
                }
            });
        }).catch(() => {
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถเชื่อมต่อฐานข้อมูลได้',
                timer: 5000,
                timerProgressBar: true,
            });
        });
    }

    const ClearInput = () => {
        Data.current.name_category =  '';

        const getid = document.getElementById("name_category") as HTMLInputElement;
        getid.value = "";
    }

    const Get_Work = () => {
        API_Get_Work('').then(res => {
            setWork(res.data);
        }).catch(() => {
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถเชื่อมต่อฐานข้อมูลได้',
                timer: 5000,
                timerProgressBar: true,
            });
        });
    }

    const onChangeData = (event : ChangeEvent<any>) : void => {
        let data = {
            ...Data.current,
            [event.target.id]: event.target.value
        }
        Data.current = data;
    }

    useEffect(() => {
        onEsc();
        Get_Work();
    }, []);

    return (
        <>
        <button onClick={() => setToggle(!Toggle)} className="button is-link">เพิ่มประเภท</button>
        <div className={`modal ${Toggle ? 'is-active' : ''}`}>
            <div onClick={() => setToggle(!Toggle)} className="modal-background" />
            <div className="modal-card">
                <header className="modal-card-head">
                <p className="modal-card-title">เพิ่มหมวดงาน</p>
                <button onClick={() => setToggle(!Toggle)} className="delete" aria-label="close" />
                </header>
                <section className="modal-card-body">
                    <div className="field">
                        <label className="label">หมวดงาน</label>
                        <div className="control">
                            <select defaultValue="" id="id_work" onChange={onChangeData} className={`input ${Error.id_work ? 'is-danger' : ''}`}>
                                <option disabled value="">กรุณาเลือกหมวดงาน</option>
                                {
                                    Work.length > 0 &&
                                    Work.map((item, index) => (
                                        <option key={index} value={item['id_work']}>{item['name_work']}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="field">
                        <label className="label">ชื่อหมวดงาน</label>
                        <div className="control">
                            <input onKeyPress={onEnter} onChange={onChangeData} 
                            autoFocus className={`input ${Error.name_category ? 'is-danger' : ''}`} type="text" id="name_category" placeholder="หมวดงาน" />
                        </div>
                    </div>

                    <button onClick={() => onSubmitData()} className="button is-link is-fullwidth">เพิ่มหมวดงาน</button>
                </section>
            </div>
        </div>

        </>
    );
}

export default Category_Add;